import React, { useEffect, useState } from "react";
import { BASE_URL_API } from "../environment";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
  Alert,
} from "react-bootstrap";

export const BscustSetting = ({ customerId }) => {
  const [gstData, setGstData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [formData, setFormData] = useState({
    gstNumber: "",
    companyName: "",
    city: "",
    PIN: "",
    address: "",
  });
  const [loading, setLoading] = useState(true);
  const customer_id = localStorage.getItem("customer_id");

  const fetchCustomerDetails = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${BASE_URL_API}customers/getcustomerdetail/${customer_id}`
      );
      const data = await res.json();

      if (res.ok) {
        setProfileData(data.customer_profile || null);
        setGstData(data.customer_data?.gstNumber ? data.customer_data : null);
      }
    } catch (err) {
      console.error("Error fetching customer data:", err);
    } finally {
      setLoading(false);
    }
  };
  console.log("the profile data is",profileData);

  useEffect(() => {
    if (customer_id) {
      fetchCustomerDetails();
    }
  }, [customer_id]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (let [key, value] of Object.entries(formData)) {
      if (!value.trim()) {
        alert(`${key} is required`);
        return;
      }
    }

    try {
      const res = await fetch(`${BASE_URL_API}customers/addgst`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, customer_id }),
      });

      const result = await res.json();
      if (res.ok) {
        alert("GST details saved successfully!");
        setGstData(result);
        fetchCustomerDetails();
      } else {
        alert(result?.message || "Error saving GST details.");
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("Error while saving GST details.");
    }
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row className="g-4">
        {/* Profile Details */}
        <Col md={6}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <h4 className="mb-4 text-center text-primary">Profile Details</h4>
              {profileData ? (
                <>
                  <p>
                    <strong>Name:</strong> {profileData.name}
                  </p>
                  <p>
                    <strong>Email:</strong> {profileData.email}
                  </p>
                  <p>
                    <strong>Phone:</strong> {profileData.mobile}
                  </p>
                </>
              ) : (
                <Alert variant="warning">Profile details not available.</Alert>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* GST Details */}
        <Col md={6}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <h4 className="mb-4 text-center text-success">
                Customer GST Details
              </h4>

              {gstData ? (
                <>
                  <p>
                    <strong>GST Number:</strong> {gstData.gstNumber}
                  </p>
                  <p>
                    <strong>Company Name:</strong> {gstData.companyName}
                  </p>
                  <p>
                    <strong>City:</strong> {gstData.city}
                  </p>
                  <p>
                    <strong>PIN:</strong> {gstData.PIN}
                  </p>
                  <p>
                    <strong>Address:</strong> {gstData.address}
                  </p>
                </>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>GST Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="gstNumber"
                      value={formData.gstNumber}
                      onChange={handleChange}
                      placeholder="Enter GST Number"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      placeholder="Enter Company Name"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder="Enter City"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>PIN</Form.Label>
                    <Form.Control
                      type="text"
                      name="PIN"
                      value={formData.PIN}
                      onChange={handleChange}
                      placeholder="Enter PIN Code"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Enter Address"
                      required
                    />
                  </Form.Group>

                  <div className="d-grid">
                    <Button variant="success" type="submit">
                      Save GST Details
                    </Button>
                  </div>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
